import { monitorForExternal } from '@atlaskit/pragmatic-drag-and-drop/external/adapter';
import { makeFixForAdapter } from './make-fix-for-adapter';
function watchForInteractionStart({
  start
}) {
  return monitorForExternal({
    onDragStart() {
      start();
    }
  });
}
function watchForInteractionEnd({
  stop
}) {
  return monitorForExternal({
    onDrop() {
      stop();
    }
  });
}
const api = makeFixForAdapter({
  watchForInteractionStart,
  watchForInteractionEnd
});
export function disableDraggingToCrossOriginIFramesForExternal() {
  return api.registerUsage();
}